<script setup lang="ts">
defineProps<{
  hasCancel?: boolean
}>()

const emit = defineEmits<{
  cancel: []
}>()
</script>

<template>
  <div class="buttons">
    <UiButton
      type="primary"
      button-type="submit"
      data-test="button-submit"
      class="buttons__button"
    >
      Submit
    </UiButton>

    <UiButton
      v-if="hasCancel"
      type="secondary"
      data-test="button-cancel"
      class="buttons__button"
      @click="emit('cancel')"
    >
      Cancel
    </UiButton>
  </div>
</template>

<style lang="scss" scoped>
.buttons {
  display: flex;
  gap: var(--app-spacer-16);

  @include max-width(md) {
    flex-direction: column;
  }
}

.buttons__button {
  flex: 1;
}
</style>
